module.exports = require("@cimpress-technology/generic-attribute-model");